var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer py-5"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8 mx-auto text-center mt-1"},[_c('p',{staticClass:"mb-0 text-secondary"},[_vm._v("\n          Desarrollado por "),_c('a',{attrs:{"href":"https://ticktaps.com/"}},[_vm._v("Ticktaps")])])])])])])
}]

export { render, staticRenderFns }